import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss']
})
export class loginErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
